import { useEffect } from 'react';
import { useQuery } from 'hooks/useCustomQuery';
import getSBCsByLocation from 'API/SBC/getSBCsByLocation';

const useGetSBCsByLocation = (locationId, setTableData, gridRef, colDefs) => {
    const query = useQuery({
        queryKey: ['SBCs', locationId],
        queryFn: () => getSBCsByLocation(locationId),
        enabled: !!locationId,
        staleTime: 5 * 60 * 1000,
        retry: 2,
        refetchOnWindowFocus: false,
    });

    useEffect(() => {
        if (query.data) {
            setTableData({
                columns: colDefs,
                data: query.data,
            });

            gridRef?.current?.api?.applyColumnState({
                state: [{ colId: 'priority', sort: 'asc' }],
            });
        }
    }, [query.data, setTableData, colDefs, gridRef]);

    return {
        ...query,
        refetch: query.refetch,
        isRefetching: query.isRefetching,
        isFetching: query.isFetching,
    };
};

export default useGetSBCsByLocation;
